// 体验九畴云市 · 五角色模拟运营环境数据

export const experienceRoles = [
  {
    id: 'consumer',
    icon: 'ri-shopping-bag-3-line',
    name: '我是消费者',
    desc: '体验从找商品到消费评价的完整链路。',
    steps: ['TOMA', '找商品', '下单', '消费', '评价'],
  },
  {
    id: 'sheyuan',
    icon: 'ri-user-search-line',
    name: '我是云社员',
    desc: '体验寻货、建货架、分享与贡献结算。',
    steps: ['找货', '创建数字货架', '分享', '订单', '贡献'],
  },
  {
    id: 'shopkeeper',
    icon: 'ri-store-2-line',
    name: '我是云店长',
    desc: '体验开店、选品、上架与经营数据。',
    steps: ['开店', '选品', '上架', '订单', '客户', '数据'],
  },
  {
    id: 'supplier',
    icon: 'ri-truck-line',
    name: '我是供应商',
    desc: '体验商品数字化、ePin 与数字货架交易。',
    steps: ['商品', 'ePin', '审核', '数字货架', '交易'],
  },
  {
    id: 'operator',
    icon: 'ri-government-line',
    name: '我是县域运营者',
    desc: '体验建节点、招商与数据看板。',
    steps: ['建节点', '招云店', '招云社员', '供应链', '数据看板'],
  },
];

// 运营面板 · 下单与清分数据看板（模拟）

export const operationOrderPool = [
  { buyer: '张先生', role: '消费者', item: '高山云雾茶礼盒' },
  { buyer: '李姐', role: '云社员', item: '县域土鸡蛋 30 枚' },
  { buyer: '王老板', role: '云店长', item: '农家腊肉 500g' },
  { buyer: '陈女士', role: '消费者', item: '数字聚餐套餐 A' },
  { buyer: '刘叔', role: '供应商', item: '脐橙 ePin 溯源' },
  { buyer: '赵同学', role: '云社员', item: '手工豆腐乳 2 瓶' },
];

export const settlementParties = [
  { name: '供应商', pct: 60, note: '供货' },
  { name: '云店 / 云社员', pct: 15, note: '销售' },
  { name: '推荐人', pct: 8, note: '分享' },
  { name: '县域运营主体', pct: 6, note: '节点' },
  { name: '平台', pct: 5, note: '服务' },
  { name: '履约服务', pct: 4, note: '配送' },
  { name: '产业基金', pct: 2, note: '沉淀' },
];

export const operationMetrics = [
  { label: '累计交易笔数（模拟）', value: '186,420', icon: 'ri-exchange-line' },
  { label: '今日订单（模拟）', value: '3,286', icon: 'ri-shopping-cart-2-line' },
  { label: '清分笔数（模拟）', value: '2,947', icon: 'ri-flow-chart' },
  { label: '对账一致率', value: '100%', icon: 'ri-shield-check-line' },
];